import {observer} from "mobx-react-lite";
import React, {useContext, useEffect} from "react";
import {NavLink, useHistory} from "react-router-dom";
import {Currency} from "../../../app/models/currency";
import {Exchange} from "../../../app/models/exchange-types";
import {Store} from "../../../app/stores/store-root";
import {Fragment} from 'react'

const ExchangeRatesList = () => {
    const history = useHistory();
    const store = useContext(Store);
    const {loadExchanges, exchanges} = store.Exchanges;
    useEffect(() => {
        loadExchanges();
    }, []);
    return (
        <Fragment>
            <div className='flex justify-end mb-8'>
                <button type="button"
                        onClick={()=>history.push('/rates/create')}
                        className="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-150">
                    Create New Exchange Rate
                </button>
            </div>
            <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className={'bg-gray-300'}>
                                <tr>
                                    <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                        Name
                                    </th>
                                    <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                        Exchange Rate
                                    </th>
                                    <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                        Sabbur Rate
                                    </th>

                                    <th className="px-6 py-3 bg-gray-50"></th>
                                </tr>
                                </thead>
                                <tbody>
                                {exchanges.map((item: Exchange) => <tr className="bg-white">
                                    <td className="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">
                                        {item.Label}
                                    </td>
                                    <td className="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                                        {item.ExchangeRate}
                                    </td>
                                    <td className="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                                        {item.AgencyRate}
                                    </td>
                                    <td className="px-6 py-4 whitespace-no-wrap text-right text-sm leading-5 font-medium">
                                        <button
                                            onClick={() => history.push(`/rates/edit/${item.Id}`)}
                                            className="text-indigo-600 hover:text-indigo-900"
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>)}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>

    );
};

export default observer(ExchangeRatesList);
